import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dfb93c4a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "chatcomment__section" }
const _hoisted_2 = { class: "chatcomment__area" }
const _hoisted_3 = { class: "chatcomment__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Comments", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "|", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", null, "Chats", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommentsComponent = _resolveComponent("CommentsComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: _normalizeClass(["comment__wrapper", { active: $props.isShowDashboard.type === 'comment' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.onClickShow('comment')))
        }, [
          _hoisted_4,
          _createElementVNode("span", null, _toDisplayString($props.projectComments.length), 1)
        ], 2),
        _hoisted_5,
        _createElementVNode("div", {
          class: _normalizeClass(["chat__wrapper", { active: $props.isShowDashboard.type === 'chat' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.onClickShow('chat')))
        }, [
          _hoisted_6,
          _createElementVNode("span", null, _toDisplayString($setup.selectedUserMessages.length), 1)
        ], 2)
      ])
    ]),
    ($props.isShowDashboard.type === 'comment' && $props.isShowDashboard.isActive)
      ? (_openBlock(), _createBlock(_component_CommentsComponent, {
          key: 0,
          projectComments: $props.projectComments,
          activeComment: $props.activeComment,
          projectId: $props.projectId,
          userImagesMap: $props.userImagesMap,
          onToggleActiveComment: $setup.toggleActiveComment,
          onUpdateCommentRoomStatus: $setup.updateCommentRoomStatus
        }, null, 8, ["projectComments", "activeComment", "projectId", "userImagesMap", "onToggleActiveComment", "onUpdateCommentRoomStatus"]))
      : _createCommentVNode("", true)
  ]))
}